module.exports = __webpack_public_path__ + "img/Dia-Integridad.4dc21d6c.jpg";